var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScoreCardDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5966 7.702C10.4832 7.476 10.2526 7.33334 9.99993 7.33334H8.66659V0.666656C8.66659 0.298656 8.36859 0 7.99994 0C7.63128 0 7.33328 0.298656 7.33328 0.666656V7.33331H5.99994C5.74729 7.33331 5.5166 7.47597 5.40329 7.70197C5.29129 7.92797 5.31529 8.19797 5.46663 8.39997L7.46663 11.0666C7.47528 11.078 7.48863 11.082 7.49797 11.0926C7.54197 11.1446 7.59397 11.1846 7.65197 11.2213C7.67597 11.2359 7.69463 11.2553 7.72063 11.2673C7.80597 11.3073 7.89928 11.3333 7.99997 11.3333C8.10066 11.3333 8.19397 11.3073 8.27997 11.2673C8.30531 11.2553 8.32462 11.2359 8.34797 11.2213C8.40597 11.1846 8.45797 11.1446 8.50197 11.0926C8.51062 11.082 8.52462 11.078 8.53331 11.0666L10.5333 8.39997C10.6853 8.198 10.7093 7.928 10.5966 7.702Z",
    fill: "#3785F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 10C14.9647 10 14.6667 10.2987 14.6667 10.6667V12.6667C14.6667 13.7693 13.7693 14.6667 12.6667 14.6667H3.33334C2.23069 14.6667 1.33334 13.7693 1.33334 12.6667V10.6667C1.33334 10.2987 1.03534 10 0.666687 10C0.298 10 0 10.2987 0 10.6667V12.6667C0 14.5047 1.49534 16 3.33334 16H12.6667C14.5047 16 16 14.5047 16 12.6667V10.6667C16 10.2987 15.702 10 15.3333 10Z",
    fill: "#3785F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScoreCardDownload);
export default __webpack_public_path__ + "static/media/score-card-download.279a3a1ab4cdea55af485038ea5937b1.svg";
export { ForwardRef as ReactComponent };